import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit(event) {
    if ((event.ctrlKey || event.metaKey) && event.keyCode === 13) {
      this.element.form.querySelector("[type=submit]").click()
    }
  }
}
